import { assertNever } from '@freelancer/utils';
import type { BannerAjax } from './banners.backend-model';
import type { Banner } from './banners.model';
import { BannerId } from './banners.model';
import { transformCurrencyAjax } from '../currencies/currencies.transformers';

export function transformBanners(banner: BannerAjax): Banner {
  switch (banner.id) {
    case BannerId.ACCOUNT_LIMITED:
    case BannerId.CALIFORNIAN_VERIFICATION:
    case BannerId.CORPORATE_KYC:
    case BannerId.CORPORATE_UPSELL:
    case BannerId.CREDIT_CARD_VERIFICATION:
    case BannerId.CREDIT_CARD_VERIFICATION_IN_PROGRESS:
    case BannerId.EMAIL_VERIFICATION:
    case BannerId.EXAM_UPSELL:
    case BannerId.EXPIRING_CREDIT_CARD:
    case BannerId.FORCE_CREDIT_CARD_VERIFICATION:
    case BannerId.FORCE_PHONE_VERIFICATION:
    case BannerId.FREELANCER_VERIFIED:
    case BannerId.GET_STARTED:
    case BannerId.GIVE_GET:
    case BannerId.INDIA_MEMBERSHIP_MANDATE_REQUIRED:
    case BannerId.INDIA_MEMBERSHIP_RENEWAL_DISABLED:
    case BannerId.NEGATIVE_BALANCE_NOTIFICATION:
    case BannerId.KYC:
    case BannerId.MEMBERSHIP_UPGRADE_UPSELL:
    case BannerId.MISSING_FIRST_MILESTONE:
    case BannerId.NONE:
    case BannerId.PARTNERSHIP_PAYMENT_VERIFICATION:
    case BannerId.PENDING_INFORMATION_REQUEST:
    case BannerId.PHILIPPINES_VAT_REQUEST:
    case BannerId.PHONE_VERIFICATION:
    case BannerId.PFP_ELIGIBLE_UPSELL:
    case BannerId.PROJECT_MANAGEMENT:
    case BannerId.QUOTATION_FREELANCER_UPSELL:
    case BannerId.REFERRAL_BONUS:
    case BannerId.SECURE_PHONE_SETUP:
    case BannerId.TCS_VERIFICATION:
    case BannerId.TDS_PAN_REQUEST:
    case BannerId.TDS_PAN_REQUEST_FOR_AADHAAR:
    case BannerId.MXIT_RFC_REQUEST:
    case BannerId.US_TAX_TIN_REQUEST:
    case BannerId.VAT_VERIFICATION:
    case BannerId.NEW_US_TAX_TIN_REQUEST:
      return banner;
    case BannerId.WELCOME_BACK:
      return {
        id: banner.id,
        type: banner.type,
        reward: {
          amount: banner.reward.amount,
          currency: transformCurrencyAjax(banner.reward.currency),
        },
      };
    case BannerId.MEMBERSHIP_SALE:
      return {
        id: banner.id,
        type: banner.type,
        bannerUpsellColor: banner.bannerUpsellColor,
        backgroundImageUrl: banner.backgroundImageUrl,
        timeEnd: banner.timeEnd * 1000,
        title: banner.title,
        subtitle: banner.subtitle,
      };
    case BannerId.WITHDRAWAL_VIDEO_VERIFICATION_REQUIRED:
      return {
        id: banner.id,
        type: banner.type,
        videoVerificationRequestId: banner.videoVerificationRequestId,
      };
    default:
      return assertNever(banner);
  }
}
